import React from 'react';
import {useCreateMiitelCallActivityMutation, MiitelSetting} from 'api';
import {miitelCall, mountMiitelWidget} from 'helpers/miitelWidget';

const useMiitel = (uuid: string, miitelSetting: MiitelSetting) => {
  const [createMiitelCallActivity] = useCreateMiitelCallActivityMutation();

  React.useEffect(() => {
    if (!miitelSetting?.isAvailable || !miitelSetting?.isActive || !uuid)
      return;

    const createActivity = location.pathname.startsWith('/list/')
      ? (miitelSequenceId: string) =>
          createMiitelCallActivity({
            variables: {preleadProjectUuid: uuid, miitelSequenceId},
          })
      : null;

    return mountMiitelWidget(miitelSetting, createActivity);
  }, [miitelSetting, uuid]);
};

export {useMiitel, miitelCall};
